import React from 'react'
import { FormattedMessage } from 'react-intl'

import Col from 'components/Col'
import Tooltip from 'components/Tooltip'
import InfoIcon from 'assets/icons/info-icon'
import Row from 'components/Row'
import Container from 'components/Container'

import {
  AssessmentPageLabel,
  AssessmentPageLabelIconWrapper,
  AssessmentPageLabelWrapper
} from '../../../Assessment/style'

const tooltipXOffset = 0
const tooltipYOffset = 16
const HabitatsHeader = ({ label, labelHint, marginBottom }) => {
  return (
    <Container>
      <Row>
        <Col md={6} mdOffset={2}>
          <AssessmentPageLabelWrapper marginBottom={marginBottom} data-test={`label-${label}`}>
            <AssessmentPageLabel>
              <FormattedMessage id={label} />
            </AssessmentPageLabel>
            {labelHint && (
              <Tooltip
                style={{ zIndex: 1000 }}
                placement="bottom"
                trigger={['hover']}
                align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                overlay={{ label: label, infoTooltip: labelHint }}
                type="big"
              >
                <AssessmentPageLabelIconWrapper>
                  <InfoIcon />
                </AssessmentPageLabelIconWrapper>
              </Tooltip>
            )}
          </AssessmentPageLabelWrapper>
        </Col>
      </Row>
    </Container>
  )
}

export default HabitatsHeader
